import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignatureService } from 'src/app/services/signature.service';
import { LoginService } from 'src/app/services/login.service';

type PlanOption = { id: number; name: string; price: number };

@Component({
  selector: 'app-plan-selection-modal',
  templateUrl: './plan-selection-modal.component.html',
  styleUrls: ['./plan-selection-modal.component.scss'],
})
export class PlanSelectionModalComponent implements OnInit {
  plans: PlanOption[] = [];
  hasActiveSignature = false;
  status: string | null = null;
  selectedPlanId: number | null = null;

  get selectedPlan(): PlanOption | undefined {
    return this.selectedPlanId == null ? undefined : this.plans.find(p => p.id === this.selectedPlanId);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { accountId: number; accountName: string; status?: string | null },
    private readonly dialogRef: MatDialogRef<PlanSelectionModalComponent>,
    private readonly signatureService: SignatureService,
    private readonly loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.status = this.data?.status ?? null;
    this.hasActiveSignature = this.status === 'Ativa';

    this.signatureService.getPlansV2().subscribe({
      next: plans => {
        this.plans = (plans || []).map(p => ({
          id: p.id,
          name: p.name,
          price: Number(p?.prices?.[0]?.price || 0),
        }));
        this.selectedPlanId = this.plans[0]?.id ?? null;
      },
      error: () => {
        this.loginService.showMessage('Erro ao carregar planos', 3000);
        this.close();
      }
    });
  }

  openLink(): void {
    if (!this.selectedPlanId) return;
    this.signatureService.getAdministrativeAccountPlanLinkV2(this.data.accountId, this.selectedPlanId).subscribe({
      next: res => window.open(res.renewUrl, '_blank'),
      error: () => this.loginService.showMessage('Erro ao gerar link', 3000),
    });
  }

  copyLink(): void {
    if (!this.selectedPlanId) return;
    this.signatureService.getAdministrativeAccountPlanLinkV2(this.data.accountId, this.selectedPlanId).subscribe({
      next: res => navigator.clipboard.writeText(res.renewUrl).then(() => {
        this.loginService.showMessage('Link copiado', 3000);
      }),
      error: () => this.loginService.showMessage('Erro ao gerar link', 3000),
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
